import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-rss",
  "use": "logo-rss-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"logo-rss\">\n  <path fill=\"currentColor\" d=\"M6 16a2 2 0 110-4 2 2 0 010 4zM4 8.34A6 6 0 0111.66 16h-1.44A4.67 4.67 0 004 9.78V8.34zM4 4.2A10 10 0 0115.8 16h-1.36A8.67 8.67 0 004 5.57V4.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol